<template>
  <a-form :model="formModel" layout="vertical" :disabled="loading">
    <a-flex gap="middle">
      <a-form-item
        label="Название"
        name="name"
        :rules="[
          {
            required: true,
            message: 'Введите название этикетки',
            trigger: 'blur',
          },
        ]"
      >
        <a-input v-model:value="labelTemplateFormState.nameField" />
      </a-form-item>

      <a-form-item label="Предназначение этикетки" name="type">
        <a-select
          :options="labelTemplateFormState.labelTemplateDestinationTypeOptions"
          v-model:value="
            labelTemplateFormState.labelTemplateDestinationTypeField
          "
        ></a-select>
      </a-form-item>
    </a-flex>

    <a-form-item
      label="Товар для предпросмотра"
      name="previewProduct"
      v-if="previewProductFieldShow"
    >
      <a-select
        v-model:value="previewProductField"
        placeholder="Выберите товар для предпросмотра"
        :filter-option="false"
        show-search
        :loading="productsForPreviewLoading"
        :not-found-content="productsForPreviewLoading ? undefined : null"
        :options="labelTemplateStore.productsForPreviewOptions"
        @search="getProductsForPreviewOptions"
        :virtual="false"
      >
        <template v-if="productsForPreviewLoading" #notFoundContent>
          <a-spin size="small" />
        </template>
      </a-select>
    </a-form-item>

    <a-form-item label="Разрешение, DPI" name="dpi">
      <a-select
        :options="labelTemplateFormState.labelTemplateDPIResolutionOptions"
        v-model:value="labelTemplateFormState.labelTemplateDPIResolutionField"
      ></a-select>
    </a-form-item>

    <a-form-item
      label="Количество копий по умолчанию"
      name="countOfCopiesField"
      :rules="[
        {
          required: true,
          type: 'integer',
          min: 1,
          max: 50,
          message: 'Введите целое число от 1 до 50',
          trigger: 'blur',
        },
      ]"
    >
      <a-input-number
        :min="1"
        :max="50"
        :step="1"
        v-model:value="labelTemplateFormState.countOfCopiesField"
      ></a-input-number>
    </a-form-item>
  </a-form>
</template>

<script setup lang="ts">
import { useLabelTemplateFormStore } from "@/stores/labelTemplate/labelTemplateFormStore";
import { storeToRefs } from "pinia";
import { computed } from "vue";
import { LabelTemplateDestinationTypeTranslation } from "@/api/classes/labelTemplate/labelTemplateTranslates";
import { useLabelTemplateStore } from "@/stores/labelTemplate/labelTemplateStore";
import { enumStatusLoad } from "@/tools/enumStatusLoad";
import { debounce } from "@/tools/debounce";
import { LabelTemplateDestinationType } from "@/api/classes/labelTemplate/labelTemplate.dto";

defineProps<{ loading: boolean }>();

const labelTemplateFormState = useLabelTemplateFormStore();
const labelTemplateStore = useLabelTemplateStore();

const productsForPreviewLoading = computed(
  () =>
    labelTemplateStore.getProductsForPreviewOptionsStatus ===
    enumStatusLoad.LOADING,
);

const {
  nameField,
  labelTemplateDestinationTypeField,
  previewProductField,
  labelTemplateDPIResolutionField,
  countOfCopiesField,
} = storeToRefs(labelTemplateFormState);

const formModel = computed(() => ({
  name: nameField.value,
  countOfCopiesField: countOfCopiesField.value,
  dpi: labelTemplateDPIResolutionField.value,
  previewProduct: previewProductField.value,
  type: LabelTemplateDestinationTypeTranslation[
    labelTemplateDestinationTypeField.value
  ],
}));

const getProductsForPreviewOptions = debounce(
  async (search) =>
    await labelTemplateStore.getProductsForPreviewOptions(search),
  500,
);

const previewProductFieldShow = computed(
  () =>
    ![
      LabelTemplateDestinationType.Box,
      LabelTemplateDestinationType.Supply,
    ].includes(labelTemplateDestinationTypeField.value),
);
</script>

<style scoped lang="scss">
.ant-flex {
  .ant-form-item {
    flex: 1 1 50%;
  }
}

.ant-form {
  width: 350px;
}
</style>
